import { render, staticRenderFns } from "./_base-table.vue?vue&type=template&id=0a0ff111&"
import script from "./_base-table.vue?vue&type=script&lang=js&"
export * from "./_base-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a0ff111')) {
      api.createRecord('0a0ff111', component.options)
    } else {
      api.reload('0a0ff111', component.options)
    }
    module.hot.accept("./_base-table.vue?vue&type=template&id=0a0ff111&", function () {
      api.rerender('0a0ff111', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-table.vue"
export default component.exports